import { buildQuery } from "@/api/apiUtils";
import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  IShiftCreatePayload,
  IShiftListParams,
  IShiftListResponse,
  IShiftDetailResponse,
  IShiftMutationResponse,
} from "@/interface/shift.interface";


export const ShiftService = {
  createShift: async (
    payload: IShiftCreatePayload,
  ): Promise<IShiftMutationResponse> => {
    return callApi<IShiftMutationResponse>(API_ENDPOINT.createShift, {
      method: "POST",
      data: payload,
    });
  },

  getShiftList: async (
    params: IShiftListParams = {},
  ): Promise<IShiftListResponse> => {
    return callApi<IShiftListResponse>(
      `${API_ENDPOINT.shiftList}${buildQuery(params)}`,
      { method: "GET" },
    );
  },

  getShiftDetail: async (shiftId: string): Promise<IShiftDetailResponse> => {
    return callApi<IShiftDetailResponse>(
      API_ENDPOINT.shiftDetail.replace(":id", shiftId),
      { method: "GET" },
    );
  },

  updateShift: async (
    shiftId: string,
    payload: Partial<IShiftCreatePayload>,
  ): Promise<IShiftMutationResponse> => {
    return callApi<IShiftMutationResponse>(
      API_ENDPOINT.shiftUpdate.replace(":id", shiftId),
      { method: "PUT", data: payload },
    );
  },

  deleteShift: async (shiftId: string): Promise<IShiftMutationResponse> => {
    return callApi<IShiftMutationResponse>(
      API_ENDPOINT.shifDelete.replace(":id", shiftId), 
      { method: "DELETE" },
    );
  },
};